<template>
    <card>
        <h6 class='h-i'><i class="nc-icon nc-tv-2"></i>{{ displayGroup.terminalDisplayGroupName }}</h6>

        <div class='state-select'>
            <b-button :id="'popover-'+ displayGroup.terminalDisplayGroupId" size="sm" :variant="stateColor" class='dd'>
                <span> {{ selectedStateName }}</span>
                <b-icon v-if='showStateSelect' icon="caret-up-fill"></b-icon>
                <b-icon v-else icon="caret-down-fill"></b-icon>
            </b-button>
            <b-popover
                :target="'popover-'+ displayGroup.terminalDisplayGroupId"
                placement="bottom"
                :show.sync="showStateSelect">
                <div class='popover-content'>
                    <b-form-group>
                            <b-form-radio v-for="option in stateOptions" :key="option.id" v-model="selected"  :value="option.id">{{ option.label }}</b-form-radio>
                    </b-form-group>
                    <b-button variant="danger" size="sm" @click="setState">Aseta</b-button>
                    <b-button size="sm" @click="cancelSelection">Hylkää</b-button>
                </div>

            </b-popover>
    </div>
        
        <div style='clear: both;'></div>
    
        <div class="terminal-displays">
            <div v-for="disp in groupDisplays" :key="disp.displayId">
                <TerminalDisplay :display="disp"></TerminalDisplay>
            </div>
        </div>
    </card>
</template>

<script>
import terminalView from '@/store/terminals/terminalView';
import TerminalDisplay from '@/components/Terminals/TerminalDisplay.vue';

export default {
	name: 'TerminalDisplayGroup',
    props: ['displayGroup', 'terminalId', 'activeTerminalId'],
    components: {
		TerminalDisplay
	},
    data() {
        return {
            updater: null,
            showPopover: false,
            /*
            stateOptions: [
                { id: '1', label: 'Normaali' },
                { id: '2', label: 'Ei liikennettä' },
                { id: '3', label: 'Palohälytys' },

            ],
            */
            selected: "0",
            confirmed: "0",
            showStateSelect: false,
            states: null
           
        };
    },
    computed: {
        selectedState(){
            let ss;
            if(this.states){
                ss = this.states.find(s => s.displayGroupStateId == this.confirmed);
            }
            return ss;
        },

        selectedStateName(){ 
            let name = "-";
            if(this.selectedState)
                name = this.selectedState.name; 

            return name;
        },
        stateColor(){
            return (this.selectedState && this.selectedState.displayGroupStateId > 0) ? "warning" : "success";
        },

        stateOptions(){ 
            var optionList = [];
            
            if(this.states){
                for (let item of this.states) {
                    optionList.push({ id: item.displayGroupStateId, label: item.name})
                }
            }

            return optionList;
        },
        groupDisplays() {
             return this.$store.state.terminalView.displaysByGroup[this.displayGroup.displayGroupId];
        }
    },
    methods: {
        update() {
            clearTimeout(this.updater);
            if (this.terminalId == this.activeTerminalId) {
                this.$store.dispatch('terminalView/getGroupDisplays', this.displayGroup.displayGroupId);
            }
            this.updater = setTimeout(this.update, 30000);
        },
        setState(){
            // todo
            this.confirmed = this.selected;

            this.showStateSelect = false;
        },
        cancelSelection(){
            this.showStateSelect = false;
        },

        getStates(){
            this.$traveller_http.get('/traveller/restui/terminals/getDisplayGroupStates', { params: { "displaygroupid": this.displayGroup.displayGroupId } })
            .then( response => {
                //console.log(response.data)
                this.states = response.data;
            })
            .catch( () => {} ) 
            .finally( () => {} ); 
        }
    },
    watch: {
        activeTerminalId() {
            this.update();
        }
    },
    created() {
		if (!this.$store.state.terminalView) {
            this.$store.registerModule("terminalView", terminalView);
        }
        this.update();


        this.getStates();
    },
    beforeDestroy() {
        clearTimeout(this.updater);
    }
};
</script>
